import {Component, Input, OnInit} from '@angular/core';
import {AvisObject} from "../../../../../common/components/form/models/avis-object";

@Component({
  selector: 'app-avis-response-values',
  templateUrl: './avis-response-values.component.html',
  styleUrls: ['./avis-response-values.component.scss']
})
export class AvisResponseValuesComponent implements OnInit {
  @Input() avis_obj: AvisObject;
  constructor() { }

  ngOnInit(): void {
  }

}
